import { Injectable } from "@angular/core";
import {
  finalize,
  Subscription,
  timer
} from "rxjs";
import { AppConfigService } from "@citi-gcg-173875/citi-utils";
import { HttpService } from "@citi-gcg-173875/citi-http";

@Injectable({providedIn:'root'})
export class InactivityService {
  private _sessionTimeoutSubscription: Subscription;
  private defaultTimeout = 180;

  constructor(
    private _appConfigService: AppConfigService,
    private _httpService: HttpService
  ) {}

  private initiateTimer() {
    console.log("##Initiate ideal timer",new Date());
    let sessionTimeout = this._appConfigService.getSessionServiceConfig()
      .sessionTimeout;
    let keepAliveInterval = this._appConfigService.getSessionServiceConfig()
      .keepAliveInterval;
    let preTimeout = sessionTimeout ? sessionTimeout : this.defaultTimeout;
    this._sessionTimeoutSubscription = new Subscription();
    this._sessionTimeoutSubscription.add(
      timer((preTimeout * 1000), 1000).subscribe({
        next: x => {
          console.log("##inactivity timer X === > ", x);
          if (x === keepAliveInterval) {
            // existing logic for Demoted and landing on Homepage
            console.log(
              "## Pre login failure case for token expiry - demotedCustomerSignoff", new Date()
            );
            this._sessionTimeoutSubscription.add(this.deleteToken()
              .subscribe());
          }
        },
        error: err => {
          console.log("Inactivity Demoted Err: %s", err);
        },
        complete: () => {
          console.log("Inactivity complete");
        }
      })
    );
  }
  public activityHandler(): void {
    if(this._sessionTimeoutSubscription) this._sessionTimeoutSubscription.unsubscribe();
    this.initiateTimer();
  }

  public deleteToken(){
    const options = {
      headers: { tenantId: "tenantId", errorPage: "errorPage" }
    };
    return this._httpService
    .delete(`/digital/security/auth/demotedCustomerSignoff`, options)
    .pipe(
      finalize(() => {
        this._sessionTimeoutSubscription.unsubscribe();
      })
    );
  }
}
